module.exports = __webpack_public_path__ + "static/images/callout_1.21a2a5440e65136db82a34fe2ba116cf.jpg";